/**
 * 与业务/场景有关的工具函数
 * 原则：
 *  与业务有关
 *  功能尽量单一
 *  功能描述清晰,使用场景清晰
 *  单元测试补全
 */
import _ from 'lodash'
import { Message } from '@didi-pebble/pebble-design-vue'
import config from '@/config/build'
import qs from 'qs'
import { getCommonParams, transferConfig } from '@/utils'

/**
 * 表单、info 布局结构
 * @param  {[type]} list 配置列表
 * @return {[type]}      结构化后数据
 */

export function gridFormat(list) {
  const gridFormat = []
  let linePointer = 0
  let tempGrid = []
  list.forEach(config => {
    if (_.get(config, 'grid') !== linePointer) {
      linePointer = config.grid
      if (tempGrid.length) {
        gridFormat.push(tempGrid)
        tempGrid = []
      }
    }
    tempGrid.push(config)
  })
  gridFormat.push(tempGrid)
  return gridFormat
}

/**
 * 1. 输入url，params，自动拼接url和查询参数
 * 2. 输入xxx.xxx.xxx自动转换url + 参数
 * @param url：下载链接 || xxx.xxx.xxx
 * @param params: 查询拼接参数
 * @param options.isFilterEmptyParams: 是否过滤空参数
 * @param options.isAddCommonParams: 是否添加公共参数(timezone,ticket,country)
 * @returns {string|*}
 */
export function prefixUrl(
  url,
  params,
  options = { isFilterEmptyParams: false, isAddCommonParams: false },
) {
  let tmpParams = { ...params }
  if (options.isFilterEmptyParams) {
    // 过滤错误函数
    tmpParams = _.omitBy(tmpParams, v => _.isNaN(v) || _.isUndefined(v) || _.isNull(v) || v === '')
  }
  if (options.isAddCommonParams) {
    const commonParams = getCommonParams()
    tmpParams = {
      ...commonParams,
      ...tmpParams,
    }
  }
  // url处理逻辑
  if (url && url.indexOf('http') < 0) {
    if (url.indexOf('/') === 0) {
      if (/^\/?depot/g.test(url)) {
        url = config.depot + url
      } else if (/^\/?pms/g.test(url)) {
        url = config.pms + url
      } else if (/^\/?authmanage/g.test(url)) {
        url = config.dilu_api + url
      } else if (/^\/?banner-mis/g.test(url)) {
        url = config['banner-mis'] + url
      } else if (/^\/?act-mis/g.test(url)) {
        url = config['act-mis'] + url
      } else if (/^\/?activation/g.test(url)) {
        url = config.activation + url
      } else if (/^\/?msgcenter-api/g.test(url)) {
        url = config['msgcenter-api'] + url
      } else if (/^\/?m-transaction\/invoice/g.test(url)) {
        url = config['m-transaction-invoice'] + url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?m-transaction\/rfc/g.test(url)) {
        url = config['m-transaction-rfc'] + url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?deal/g.test(url)) {
        url = config.deal + url.replace(/^\/?deal/g, '')
      } else if (/^\/?home-conf/g.test(url)) {
        url = config['home-conf'] + url
      } else if (/^\/?m-transaction\/supply/g.test(url)) {
        url = config['m-transaction-supply'] + url.replace(/^\/?m-transaction/g, '')
      } else if (/^\/?workshop/g.test(url)) {
        url = config.workshop + url
      } else if (/^\/?gateway/g.test(url) || /^\/?common/g.test(url)) {
        url = config.gateway + url
      } else if (/^\/?service/g.test(url)) {
        url = config.dilu_api + url
      } else {
        url = config.api + url
      }
    } else {
      // 如果是xxx.xxx.xxx兼容
      const { transUrl, transParams } = transferConfig(url)
      tmpParams = { ...transParams, ...tmpParams }
      url = config.gateway + transUrl + '?' + qs.stringify(tmpParams)
      return url
    }
  }
  // 参数处理逻辑
  if (url.indexOf('?') !== -1) {
    return url
  } else if (!_.isEmpty(tmpParams)) {
    return url + '?' + qs.stringify(tmpParams)
  }
  return url
}

/**
 * @descripttion: 解决Message多次弹窗问题
 * @param: { message, time = 3000, type = 'error', showClose = false }
 * @return: null
 */
const messageList = []
export const messageTips = ({ message, duration = 3000, type = 'error', showClose = false }) => {
  if (messageList.length === 0) {
    messageList.push('messageBox')
    Message({
      showClose,
      message,
      type,
      duration,
      onClose: () => {
        messageList.pop()
      },
    })
  }
}

/**
 *
 * @param pathFile  require.context('./modules', true, /\.js$/),
 * @param jumpFlags
 * @returns {*}
 */
export function autoRequireRoutes(pathFile, jumpFlags = '') {
  return (modulesFiles => {
    return modulesFiles.keys().reduce((modules, modulePath) => {
      const value = modulesFiles(modulePath)
      if (jumpFlags && value[jumpFlags]) return modules
      modules.push(...value.default)
      return modules
    }, [])
  })(pathFile)
}

/**
 * 去除图片协议
 * @param imgUrl
 * @returns '//soda-static.didiglobal.com/static/soda_static/gattaran/c.png'
 */
export function rmProtocol(url) {
  if (typeof url !== 'string') return ''
  return url.replace(/^https:|^http:/, '')
}

/**
 * 存储菜单展开收起的状态
 * @returns {{}|{add(*): void, get(): {}, save(): void, remove(*): void}}
 */
let obj = {}
export const OPEN_CLOSE = {
  open: 1, // 展开状态
  close: 0, // 关闭状态
}
export function useOpendsStore() {
  const opendsStoreKey = 'gtr_opends_keys'
  const pre = window.localStorage.getItem(opendsStoreKey)
  try {
    obj = {
      ...JSON.parse(pre || '{}'),
      ...obj,
    }
  } catch (e) {}
  return {
    get() {
      return obj
    },
    getOpens() {
      return Object.entries(obj)
        .filter(i => i[1] === OPEN_CLOSE.open)
        .map(i => i[0])
    },
    open(key) {
      obj[key] = OPEN_CLOSE.open
    },
    close(key) {
      obj[key] = OPEN_CLOSE.close
    },
    save() {
      window.localStorage.setItem(opendsStoreKey, JSON.stringify(obj))
    },
  }
}

/**
 * 路由调度器
 * @param { to, from, actuator(执行器), init(控制执行器执行))) }
 * @returns
 */
const list = []
let timer = null

export function RouteScheduler(to, from, actuator, init = false) {
  // 控制执行器是否初次执行
  init = init || from === '/'
  // 推入所有路径
  list.push(to)
  // 设置定时器
  if (!timer) {
    timer = setTimeout(() => {
      if (compare(list) || init) actuator()
      timer = null
    }, 0)
  }
}

/**
 * 过滤重定向路由
 * @param { [] } list
 * @returns boolean
 */
function compare(list) {
  if (list.length <= 1) {
    return false
  }
  const cur = list.shift()
  const next = list[0]
  // 当前path是否包含上一个path
  if (next.indexOf(cur) !== -1) {
    return compare(list)
  } else {
    return true
  }
}
